export default "__VITE_ASSET__B6bQA5HO__"